// extracted by mini-css-extract-plugin
export default {"error":"theme--error--2muSEDBu"};